/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCurrentUserHospitalChatSignatureRequest
 */
export interface UpdateCurrentUserHospitalChatSignatureRequest {
    /**
     * User's hospital chat signature (max 170 characters)
     */
    hospital_chat_signature: string;
}

/**
 * Check if a given object implements the UpdateCurrentUserHospitalChatSignatureRequest interface.
 */
export function instanceOfUpdateCurrentUserHospitalChatSignatureRequest(value: object): value is UpdateCurrentUserHospitalChatSignatureRequest {
    if (!('hospital_chat_signature' in value) || value['hospital_chat_signature'] === undefined) return false;
    return true;
}

export function UpdateCurrentUserHospitalChatSignatureRequestFromJSON(json: any): UpdateCurrentUserHospitalChatSignatureRequest {
    return UpdateCurrentUserHospitalChatSignatureRequestFromJSONTyped(json, false);
}

export function UpdateCurrentUserHospitalChatSignatureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCurrentUserHospitalChatSignatureRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hospital_chat_signature': json['hospital_chat_signature'],
    };
}

export function UpdateCurrentUserHospitalChatSignatureRequestToJSON(json: any): UpdateCurrentUserHospitalChatSignatureRequest {
    return UpdateCurrentUserHospitalChatSignatureRequestToJSONTyped(json, false);
}

export function UpdateCurrentUserHospitalChatSignatureRequestToJSONTyped(value?: UpdateCurrentUserHospitalChatSignatureRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hospital_chat_signature': value['hospital_chat_signature'],
    };
}

